import { render, staticRenderFns } from "./LeagueManage.vue?vue&type=template&id=8c17e342&scoped=true&"
import script from "./LeagueManage.vue?vue&type=script&lang=js&"
export * from "./LeagueManage.vue?vue&type=script&lang=js&"
import style0 from "./LeagueManage.vue?vue&type=style&index=0&id=8c17e342&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c17e342",
  null
  
)

export default component.exports